<div class="nouvelle-declaration">
    <div class="titre-nouvelle-declaration">
        <img src="/assets/images/Polygon Rose.png" alt="icone-deco" class="polygone-rose" />
        <span class="texte-nouvelle-declaration">NOUVELLE <br>DECLARATION</span>
    </div>

    <div class="cadre-formulaire-nouvelle-declaration">
        <div class="formulaire-nouvelle-declaration">
            <span class="titre-projet">
                Projet
            </span>

            <div class="champ-formulaire">
                <label class="label-formulaire-declaration">Date des travaux<span class="asterisk-red">*</span></label>

                <div class="zone-date-formulaire">
                    <div class="libelle-et-calendrier">
                        <label class="libelle-calendrier">Début</label>
                        <p-calendar id="field_dateDebutTravaux"
                                    name="dateDebutTravaux"
                                    [(ngModel)]="declaration.dateDebutTravaux"
                                    dateFormat="dd/mm/yy"
                                    placeholder="JJ/MM/AAAA"
                                    appendTo="body"
                                    [baseZIndex]="1040"
                                    class="calendrier"></p-calendar>
                    </div>

                    <div class="libelle-et-calendrier">
                        <label class="libelle-calendrier">Fin</label>
                        <p-calendar id="field_dateFinTravaux"
                                    name="dateFinTravaux"
                                    [minDate]="declaration.dateDebutTravaux"
                                    [(ngModel)]="declaration.dateFinTravaux"
                                    dateFormat="dd/mm/yy"
                                    placeholder="JJ/MM/AAAA"
                                    (onSelect)="onDateFinSelect($event)"
                                    appendTo="body"
                                    [baseZIndex]="1040"
                                    class="calendrier"></p-calendar>
                    </div>
                </div>
            </div>

            <div class="champ-formulaire">
                <label class="label-formulaire-declaration">Nom du projet<span class="asterisk-red">*</span></label>
                <input type="text" 
                        id="projectName" 
                        class="nom-projet"
                        name="projectName" 
                        maxlength="80" 
                        [(ngModel)]="declaration.nomProjet"
                        placeholder="Nom du projet" />
            </div>

            <div class="champ-formulaire">
                <label class="label-formulaire-declaration">Objectif<span class="asterisk-red">*</span></label>
                <ng-select class="objectifs-liste"  
                            [items]="fonctionsOptions" 
                            bindLabel="text" 
                            name="fonction" 
                            id="field_fonction" 
                            [(ngModel)]="selectedFonction" 
                            (change)="fonctionChange($event, false)"></ng-select>
            </div>

            <div class="champ-formulaire">
                <div class="col-md-6 dropdown-no-padding" *ngIf="selectedFonction && selectedFonction.children.length > 0">
                    <ng-select class="objectifs-liste" 
                                [items]="selectedFonction.children" 
                                bindLabel="text" 
                                name="fonction_child" 
                                id="field_fonction_child" 
                                [(ngModel)]="selectedFonctionFinal" 
                                (change)="fonctionChange($event, true)"></ng-select>
                </div>
            </div>

            <div class="champ-formulaire" *ngIf="isExploit">
                <label class="label-formulaire-declaration">Quantité d'eau prélevée prévue</label>
                <label>Volume annuel (m3)</label>
                <input id="volumeAnnuel"
                        class="nom-projet"
                        type="number" 
                        placeholder="Nombre de m3"
                        [(ngModel)]="declaration.prelevement"
                        (blur)="changementVolumePrelevement()"
                        min=0>
            </div>

            <div *ngIf="isExploit && declaration.prelevement > 0">
                <label class="label-formulaire-declaration">Usage de l'eau<span class="asterisk-red">*</span></label>
                <br>
                <div *ngIf="isForageDomestique()">
                    <div class="checkbox_box" *ngIf="declaration.prelevement > 0 && declaration.prelevement <= 1000">
                        <div class="usage-eau-domestique">
                            <input id="arrosage" type="checkbox" [(ngModel)]="arrosage" (change)="updateUsagesFordom($event)" class="check-box-usage-eau-domestique"/>
                            <label for="arrosage" class="label-usage-eau-domestique">ARROSAGE</label>
                        </div>

                        <div class="usage-eau-domestique">
                            <input id="lavagenettoyage" type="checkbox" [(ngModel)]="lavageNettoyage" (change)="updateUsagesFordom($event)" class="check-box-usage-eau-domestique" />
                            <label for="lavagenettoyage" class="label-usage-eau-domestique">LAVAGE-NETTOYAGE</label>
                        </div>

                        <div class="usage-eau-domestique">
                            <input id="abreuvage" type="checkbox" [(ngModel)]="abreuvage" (change)="updateUsagesFordom($event)" class="check-box-usage-eau-domestique" />
                            <label for="abreuvage" class="label-usage-eau-domestique">ABREUVAGE</label>
                        </div>

                        <div class="usage-eau-domestique">
                            <input id="piscinebassin" type="checkbox" [(ngModel)]="piscineBassin" (change)="updateUsagesFordom($event)" class="check-box-usage-eau-domestique" />
                            <label for="piscinebassin" class="label-usage-eau-domestique">PISCINE-BASSIN</label>
                        </div>

                        <div class="usage-eau-domestique">
                            <input id="sanitaire"  type="checkbox" [(ngModel)]="sanitaire" (change)="updateUsagesFordom($event)" class="check-box-usage-eau-domestique" />
                            <label for="sanitaire" class="label-usage-eau-domestique">SANITAIRE</label>
                        </div>

                        <div class="usage-eau-domestique">
                            <input id="consommationhumaine" type="checkbox" [(ngModel)]="consommationHumaine" (change)="updateUsagesFordom($event)" title="Au sens de l’article R. 1321-1 du code de la santé publique"  class="check-box-usage-eau-domestique" />
                            <label for="consommationhumaine" class="label-usage-eau-domestique">CONSOMMATION-HUMAINE</label><i class="fas fa-info-circle" [title]="tooltip()"></i>
                        </div>
                        <p *ngIf="consommationHumaine">
                            <span>En cas d’utilisation de l’eau pour la consommation humaine : pour un usage unifamilial , une analyse de l’eau de type P1, à l’exception du chlore, définie dans l’arrêté du 11 janvier 2007 (relatif au programme de prélèvements et d’analyses du contrôle sanitaire pour les eaux fournies par un réseau de distribution) doit être réalisée et jointe à la déclaration ; pour les ouvrages à réaliser l’analyse est transmise après travaux ;
                            <br/>
                            pour les autres cas, une autorisation préfectorale doit être demandée au titre de l’article L.1321-7 du code de la santé publique.
                            </span>
                        </p>
                    </div>
                </div>

                <div *ngIf="!isForageDomestique()">
                    <dup-hierarchical-select class="col-md-6 dropdown-no-padding" 
                                             (onHierarchicalSelectChange)="usageChange($event)" 
                                             [options]="usagesOptions" 
                                             [selectedOption]="selectedUsage" 
                                             [requiredUsage]="true"></dup-hierarchical-select>                    
                </div>

            </div>

            <div *ngIf="isSubstance">
                <label class="col-md-5 form-control-label" for="field_fonction">Substance <span class="asterisk-red">*</span></label>
                <ng-select class="col-md-6 dropdown-no-padding" 
                            [items]="substancesOptions" 
                            bindLabel="text" 
                            name="substance" 
                            id="field_substance" 
                            [(ngModel)]="selectedSubstance" 
                            (change)="parentSubstanceChange($event)"></ng-select>
            </div>
                
            <div *ngIf="selectedSubstance">
                <ng-select class="col-md-6 dropdown-no-padding" 
                           [items]="selectedSubstance.children" 
                           bindLabel="text" 
                           name="substance_child" 
                           id="field_substance_child" 
                           (change)="substanceChange($event)" 
                           [(ngModel)]="selectedSubstanceFinal"></ng-select>
            </div>
        </div>
    </div>
</div>